import React from 'react';
import { CircularProgress, Backdrop } from '@mui/material';

interface LoadingSpinnerProps {
  open: boolean;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ open }) => {
  return (
    <Backdrop open={open} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <CircularProgress color="primary" />
    </Backdrop>
  );
};
